import { useEffect, useState } from 'preact/hooks'
import { useTranslation } from 'react-i18next'
import Input from './Input'
import Checkbox from './Checkbox'
import { Model } from '@/types'

type Props = {
	transport: Model.CompanyTransport
    translation: string
}

const ToggleableTransport: FC<Props> = (p: Props) => {
	const { t } = useTranslation(p.translation)
	const [ transport, setTransport ] = useState<Model.CompanyTransport>({} as Model.CompanyTransport)
    const [ useTransport, setUseTransport ] = useState<boolean>(false)

    useEffect(() => {
        if (p.transport) {
            setTransport(p.transport)
            setUseTransport(p.transport != undefined ? true : false)
        }
    }, [p.transport])

	return (
		<div class='mt-6'>
            <Checkbox
                class='justify-center'
                label={t('company_transport')}
                checked={useTransport}
                onChange={() => setUseTransport(!useTransport)}
            />
            <fieldset disabled={!useTransport}>
                <Input
                    autocomplete='on'
                    required
                    name='company_transport[departure]'
                    label={t('departure')}
                    defaultValue={transport?.departure}
                />
                <Input
                    autocomplete='on'
                    required
                    name='company_transport[arrival]'
                    label={t('arrival')}
                    defaultValue={transport?.arrival}
                />
                <Input
                    className='span3'
                    required
                    units='km'
                    name='company_transport[km]'
                    label={t('total_km')}
                    defaultValue={transport?.km}
                />
                <Input
                    className='span3'
                    required
                    units='hours'
                    name='company_transport[hours]'
                    label={t('total_hours')}
                    defaultValue={transport?.hours}
                />
            </fieldset>
        </div>
        
		
	)

}
export default ToggleableTransport
